// src/services/paymentService.js
import api from './api';

export const paymentService = {
    // Tüm ödemeleri getir
    getAllPayments: async (page = 1, limit = 20, filters = {}) => {
        const { status = '', plan = '', date_from = '', date_to = '' } = filters;

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            ...(status && { status }),
            ...(plan && { plan }),
            ...(date_from && { date_from }),
            ...(date_to && { date_to })
        });

        const response = await api.get(`/admin/payments?${params}`);
        return response.data;
    },

    // Ödeme detayını getir
    getPaymentDetail: async (paymentId) => {
        const response = await api.get(`/admin/payments/${paymentId}`);
        return response.data;
    },

    // Ödeme istatistiklerini getir
    getPaymentStats: async (period = 'today') => {
        const response = await api.get(`/admin/statistics?period=${period}`);
        return response.data;
    },

    // Manuel ödeme onaylama
    approvePayment: async (paymentId) => {
        const response = await api.post(`/admin/payments/${paymentId}/approve`);
        return response.data;
    },

    // Bekleyen ödemeleri getir
    getPendingPayments: async () => {
        const response = await api.get('/payments/pending-payments');
        return response.data;
    }
};